export const KINDS = {
  NORMAL: 'Normal',
  COMPACT: 'Compact',
} as const
